import { render, staticRenderFns } from "./ControleFeriadoExcluido.vue?vue&type=template&id=30f98c6c&"
import script from "./ControleFeriadoExcluido.vue?vue&type=script&lang=js&"
export * from "./ControleFeriadoExcluido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports